var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 49C40.4934 49 49 40.4934 49 30C49 19.5066 40.4934 11 30 11C19.5066 11 11 19.5066 11 30C11 40.4934 19.5066 49 30 49Z",
    fill: "url(#paint0_linear_2944_4773)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.5C21.5 18.5 18.5 22 17 25.5",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2944_4773",
    x1: 42.5,
    y1: 44.5,
    x2: 16.5,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.237263,
    stopColor: "#34A885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721647,
    stopColor: "#4DBD94"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandard);
export default __webpack_public_path__ + "static/media/standard.a7432ac934369946f205c818922e00b6.svg";
export { ForwardRef as ReactComponent };